import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSmartModalService } from 'ngx-smart-modal';

import { CloseType, TableService } from '../../../domain/services/table.service';
import { CurrencyPipe } from '../../../pipes/currency.pipe';
import { AppBarComponent } from '../../../components/app-bar/app-bar.component';
import { Table } from '../../../domain/models/table';

@Component({
  selector: 'app-how-to-pay',
  imports: [
    CommonModule,
    CurrencyPipe,
    AppBarComponent,
  ],
  templateUrl: './how-to-pay.component.html',
  styleUrl: './how-to-pay.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HowToPayComponent {
  total: number;
  hasCustomPayment: boolean = false;
  haveModifiers = false;

  constructor(
    private ngxSmartModalService: NgxSmartModalService,
    private tableService: TableService,
  ) {
    const table = this.tableService.getTable();
    this.total = table.remaining;
    this.hasCustomPayment = this.hasCustomPaymentMade(table);
    this.haveModifiers = this.hasFixedModifiers(table);
  }

  handleClose() {
    this.ngxSmartModalService.getModal('how-to-pay').close()
  }

  private hasCustomPaymentMade(table: Table): boolean {
    return (table.payments || []).some((p) => p.type === 'CUSTOM');
  }

  private hasFixedModifiers(table: Table): boolean {
    if (table.tipType === 'fixed') return true;
    if (table.discount > 0) return true;

    const hasFixedVoucher = (table.vouchers || []).some(
      (v) => v?.discountType === 'VALUE',
    );
    if (hasFixedVoucher) return true;

    if (table.fidelity?.discountType === 'VALUE') return true;

    // Cashback é sempre um valor fixo aplicado na mesa (user_table_cashback.cashback_value).
    // Mesma regra dos demais descontos fixos: bloqueia "Só o que consumi".
    if ((table.cashbackApplied ?? 0) > 0) return true;

    return false;
  }

  get canPayPartial(): boolean {
    return !this.hasCustomPayment && !this.haveModifiers;
  }

  handlePayment(closeType: CloseType) {
    this.tableService.setPaymenType(closeType)
    this.ngxSmartModalService.setModalData({ closeType }, 'how-to-pay');
    this.ngxSmartModalService.getModal('how-to-pay').close()
  }
}